import React from "react";
import ipvLogo from "../../IPV-PNG-logo-White-Cropped 1.png";
import qrCode from "../../qr-code.png";

const Thanks = () => {
  return (
    <div className="thanks-container">
      <div className="thanks-content">
        <div className="thanks-logo">
          <img src={ipvLogo} alt="Inflection Point Ventures Logo" />
        </div>
        <h1 className="thanks-title">Thank you for completing the form!</h1>
        <p className="thanks-message">
          Your details have been successfully submitted. Our team will review
          the information, and you’ll hear from us soon regarding the next
          steps.
        </p>
        <div className="thanks-qr-section">
          <p className="qr-message">
            Explore the investment world with our IPV App! Scan the QR code
            below to download the app and get started.
          </p>
          <img src={qrCode} alt="IPV App QR Code" className="qr-code" />
        </div>
      </div>
    </div>
  );
};

export default Thanks;
